export const environment = {
  production: true,
  base_url: 'https://api.acheitere.com.br/',
  version: '2.4.4',
  defaultSubDomain: 'acheitere',
  routeName: 'teresopolis',
  key_map: 'AIzaSyBhEbJ_HRKEIBIAllnIvZe8ch_NsQkm8Xs',
  whatsapp: '5521988133812'   // Achei Terê
  // whatsapp: '5521993867618' // Achei Terê (2)
};
